<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { getContext } from "svelte";
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { TRANSITION_DURATION } from "$lib/utils/config.js";

  const { data: contextData, xGet, yGet, xScale, yScale } = getContext("LayerCake");

  let {
    stroke = "#1696d2",
    data = undefined,
    showPoints = true,
  } = $props();

  let lineData = $derived(data ?? $contextData);

  // Compute target pixel coordinates from current data
  let targetCoords = $derived(
    lineData.map((d) => ({ x: $xGet(d), y: $yGet(d) }))
  );

  // Tweened store for smooth interpolation
  const coords = tweened([], {
    duration: TRANSITION_DURATION,
    easing: cubicOut,
    interpolate(from, to) {
      // Pad arrays to same length for interpolation
      const len = Math.max(from.length, to.length);
      const padded = (arr) =>
        Array.from({ length: len }, (_, i) => arr[i] ?? arr[arr.length - 1] ?? { x: 0, y: 0 });
      const a = padded(from);
      const b = padded(to);
      return (t) =>
        b.map((_, i) => ({
          x: a[i].x + (b[i].x - a[i].x) * t,
          y: a[i].y == null || b[i].y == null ? b[i].y : a[i].y + (b[i].y - a[i].y) * t,
        }));
    },
  });

  $effect(() => {
    coords.set(targetCoords);
  });

  function buildPathFromCoords(pts) {
    let d = "M";
    for (const pt of pts) {
      if (pt.y == null && d[d.length - 1] !== "M") {
        d = d.slice(0, -1) + "M";
      } else if (pt.y != null) {
        d += pt.x + "," + pt.y + "L";
      }
    }
    return d.slice(0, -1);
  }
</script>

<path class="path-line" d={buildPathFromCoords($coords)} stroke={stroke}></path>
{#if showPoints}
  <g class="points">
    {#each $coords as pt}
      {#if pt.y != null}
        <circle
          r="5"
          cx={pt.x}
          cy={pt.y}
          fill="white"
          {stroke}
          stroke-width="3"
        />
      {/if}
    {/each}
  </g>
{/if}

<style>
  .path-line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 4;
  }
</style>
